<gl-popup [open]="popupState.open" [size]="popupState.size">
  <div class="gl-popup__content">
    <div class="gl-popup__close" (click)="onClose()">
      <span class="glicon-close"></span>
    </div>
    <div *ngIf="popupState.icon" class="gl-popup__icon centered" [ngClass]="popupState.type">
      <span [ngClass]="popupState.icon"></span>
    </div>
    <div
      *ngIf="popupState.title"
      class="gl-popup__title"
      [ngClass]="{
        centered: popupState.class === 'center'
      }"
      [innerHTML]="popupState.title"
    ></div>
    <div
      *ngIf="popupState.text || popupState.html"
      class="gl-popup__text"
      [innerHTML]="popupState.text || popupState.html"
    ></div>
    <div *ngIf="popupState.alert" class="gl-popup__text alert" [innerHTML]="popupState.alert"></div>
    <div class="gl-popup__buttons">
      <gl-button
        color-secondary
        [text]="(popupState.cancelButtonText | translate) || ('actions.cancel' | translate)"
        *ngIf="popupState.showCancelButton"
        (onClick)="popupService.closePopup()"
      ></gl-button>
      <gl-button
        color-primary
        [text]="(popupState.confirmButtonText | translate) || ('actions.confirm' | translate)"
        (onClick)="popupService.confirmPopup()"
      ></gl-button>
    </div>
  </div>
</gl-popup>
